var _defs, _rect, _path, _rect2, _rect3, _rect4, _text, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM1IconDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2,.cls-4{fill:#000;}.cls-4{font-family:NeueMontreal-Medium, 'Neue Montreal';font-size:127.03px;font-weight:500;}.cls-3{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 72.73,
    y: 179.82,
    width: 494.54,
    height: 280.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.77,182.32v275.37H75.23V182.32h489.54M569.77,177.32H70.23v285.37h499.54V177.32h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.99,
    y: 247.89,
    width: 312.14,
    height: 190.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.99,
    y: 207.25,
    width: 34.31,
    height: 34.31
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.28,
    y: 207.25,
    width: 271.85,
    height: 34.31
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(458.85 428.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "496.21 204.34 462.33 307.58 496.21 291.93 530.09 307.58 496.21 204.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1IconDisplay);
export default __webpack_public_path__ + "static/media/m1-icon-display.ceab53166b030137c1faffa46a8dd839.svg";
export { ForwardRef as ReactComponent };